import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: null,
  success: false,
  documentData: null,
};

const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    addDocumentStart: (state) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    addDocumentSuccess: (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.documentData = action.payload;
      state.error = null;
    },
    addDocumentFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetDocumentState: (state) => {
      return initialState;
    },
  },
});

export const {
  addDocumentStart,
  addDocumentSuccess,
  addDocumentFailure,
  resetDocumentState,
} = documentsSlice.actions;

export default documentsSlice.reducer;
